<template>
  <wrap-container>
    <help-title title="Open Pay" />

    <help-list-container>
      <help-list-item tituloLista="Más información:">
        Si tenés un comercio y tenés alguna consulta/reclamo referente al
        servicio de OpenPay podrás comunicarte con un asesor especializado
        <a
          id="contactForm"
          href="https://apps.bbva.com.ar/openmarket/contacto/empresas/#"
          >ingresando aqui</a
        >
        o llamando al 0800-333-4646 de lunes a viernes de 7:30 a 18hs.<br />
        En caso de que tengas una consulta/reclamo referente a una transacción
        realizada a través de OpenPay, te pedimos que nos comentés la misma
        respondiendo éste correo.
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
